(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-related-products"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", (event) => {
  $('[data-product-recommendations] [data-product-gallery]').each((_, gallery) => {
    const $productGallery = $(gallery);
    window.productPage.enableGallery($productGallery);
  });
})


  } catch(e) { console.error(e); }
})();
})();
